<!-- 悬浮工具栏 -->
<template>
  <div class="suspended-toolbar">
    <div class="content">
      <div class="massage" @click="leave_message">
        <!-- <router-link :to="{path:'/leave-message',query:{id:content_id}}"> -->
        <img src="@/assets/images/massage.png" alt />
        <!-- </router-link> -->
      </div>
      <div class="email">
        <img src="@/assets/images/email.png" alt @click="sendEmail"  />
      </div>
      <a :href="'tel:'+phone_num" @click="call_phone" v-call="call">
        <div class="phone">
          <img src="@/assets/images/phone.png" alt />
        </div>
      </a>
    </div>
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop>
        <div class="email-content" v-if="show_email">
          <div class="tips">
            <div class="close-tips" @click="show = false, show_email =false"></div>
            <p>资料已发送到您的预留邮箱，请查收</p>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import InformationTime from '@/assets/js/Commonmethods.js'

export default {
  name: "suspended-toolbar",
  props: ["content_id","content_title","contentTagIds"],
  data() {
    return {
      show: false,
      show_email: false,
      userinfo: {},
      current_content: {}
    };
  },
  created() {
    this.userinfo = JSON.parse(localStorage.getItem("userinfo"));
    console.log(this.userinfo);
    this.$axios
      .get("/newapi/business-service-cms/cms/cms-content/" + this.content_id)
      .then(res => {
        res = res.data.data;
        this.current_content = res;
        console.log(this.current_content, "传进来的数据");
      });
  },
  mounted() {
    // console.log(this.content_id, "传进来的东西");
    // console.log(this.content_id, "传进来的东西");
    // console.log(this.contentTagIds, "传进来的东西");
  },
  methods: {
    // 打电话
    call_phone() {
      // 行为记录
      // this.commonM.Buried_point({
      //   // 活动id
      //   actId: this.current_content.id,
      //   // 行为标签id
      //   actionTagIds: "399",
      //   // 内容标签
      //   contentTagIds: this.current_content.tags,
      //   // 目标id
      //   targetId: this.current_content.id,
      //   // 目标标题
      //   targetSign: 1,
      //   // 来源标题
      //   viewTitle: this.current_content.title,
      //   // 来源地址
      //   viewUrl: window.location.href
      // });
    },
    //发送资料邮件
    sendEmail() {
      let $this = this
      if (this.isMember) {        
        this.emit({type:'send', contentTagIds:this.current_content.tags,viewTitle:this.current_content.title,})
        // InformationTime.InformationTime($this)
        if (JSON.stringify(this.current_content.annexFormatObject) == "{}") {
          this.$toast("本篇内容不支持发送到邮箱，谢谢。");
        } else {
          // 行为记录
          // this.commonM.Buried_point({
          //   // 活动id
          //   actId: this.current_content.id,
          //   // 行为标签id
          //   actionTagIds: "398",
          //   // 内容标签
          //   contentTagIds: this.current_content.tags,
          //   // 目标id
          //   targetId: this.current_content.id,
          //   // 目标标题
          //   targetSign: 1,
          //   // 来源标题
          //   viewTitle: this.current_content.title,
          //   // 来源地址
          //   viewUrl: window.location.href
          // });
          this.$axios({
            method: "post",
            url: "/newapi/business-service-cms/cms/sendMail/sendArticle",
            data: {
              mailTitle: this.current_content.title,
              addressee: this.userinfo.email,
              company: "siemens",
              nickName: this.userinfo.nickname,
              targetUrl:
                "https://www.commnowmatrix.com/" +
                this.current_content.annexFormatObject.url
            }
          }).then(res => {
            console.log(res, "邮箱发送成功");
            if (res.data.code == '00000') {
              this.show = true;
              this.show_email = true;
            }
          });
        }
      } else {
        this.$router.push({
          path: "/Regist-form",
          query:{  item: JSON.stringify(this.current_content),url: window.location.href}
        });
      }
    },
    //邮件埋点
      // send(){
     
      // },
      //电话埋点
      call(){
          return { extension: this.phone_num, isMember: true,contentTagIds:this.current_content.tags}
      },
    leave_message() {
      if (this.isMember) {
        // InformationTime.InformationTime($this)

        this.$router.push({
          path: "/leave-message",
          query: { id: this.content_id,title:this.content_title }
        });
      } else {
        this.$router.push({
          path: "/Regist-form",
         query:{ item: JSON.stringify(this.current_content),url: window.location.href}
        });
      }
      // this.emit({type:"browse", viewTitle:"文章详情/在线留言"})
    }
  }
};
</script>

<style lang='less'>
.suspended-toolbar {
  width: 52px;
  height: 144px;
  border-radius: 26px;
  background: rgba(74, 184, 212, 0.5);
  .content {
    width: 32.67px;
    height: 100%;
    margin: 0 auto;
    .massage,
    .email,
    .phone {
      width: 100%;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 24px;
        height: 24px;
      }
    }
    .massage,
    .email {
      border-bottom: 2px solid #fff;
    }
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .email-content {
      width: fit-content;
      height: fit-content;
      .tips {
        width: 315px;
        height: 125px;
        background: #fff;
        position: relative;
        border-radius: 6px;
        box-sizing: border-box;
        padding-top: 60px;
        .close-tips {
          width: 20px;
          height: 20px;
          position: absolute;
          top: 16px;
          right: 16px;
        }
        .close-tips::before {
          content: "";
          width: 22px;
          height: 1px;
          background: #9b9b9b;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) rotate(45deg);
        }
        .close-tips::after {
          content: "";
          width: 22px;
          height: 1px;
          background: #9b9b9b;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) rotate(-45deg);
        }
        p {
          color: #4a4a4a;
          font-family: "PingFangSC-Regular";
          font-size: 13px;
          font-weight: 400;
          line-height: 17px;
          text-align: center;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/public-components/Suspended-toolbar.vue